import { Type } from "@angular/core";
import { ICommand } from "../../modules/records/commands/i-command";
import { IApiService } from "../../modules/records/models/api/i-api-service";
import { Col, FilteredKeys } from "../../modules/records/models/columns/col";
import { ICol } from "../../modules/records/models/columns/i-col";
import { ICellComponent } from "../../modules/records/models/i-cell-component";

export interface IActionComponent<T extends object> extends ICellComponent<T> {
  commands: ICommand<T, IApiService<T>>[];
  onClick: (index: number) => void;
}

export class ActionCol<
    T extends object,
    C extends Type<IActionComponent<T>>,
    S extends IApiService<T>
  >
  extends Col<T, Type<IActionComponent<T>>>
  implements ICol<T, Type<IActionComponent<T>>>
{
  constructor(
    columnDef: FilteredKeys<T, InstanceType<C>["data"]>,
    searchable: boolean,
    header: string | undefined,
    override commands: ICommand<T, S>[],
    component: Type<IActionComponent<T>>,
    sortable?: boolean,
    minWidth?: string,
    sticky = false
  ) {
    super(component, columnDef, header, minWidth, searchable, false, sortable);
    this.sticky = sticky;
  }
}
